import React from 'react';
import PropTypes from 'prop-types';
import {Typography} from '@material-ui/core';
import * as Yup from 'yup';
import Dialog from 'components/Dialog';
import Form from 'components/Form';
import GridBlock from 'components/GridBlock';
import DatePicker from 'components/DatePicker';
import Checkbox from 'components/Checkbox';
import ValidationShema from 'constants/ValidationShema';
import Tr from 'translations/Translations';
import moment from 'libs/moment';
import DoubleButton from 'components/popup/components/DoubleButton';

const MIN_DELAY_DAYS = 1;

function DelayedPublicationPopup({open, onCancel, onConfirm}) {
    const minDelayedPublicationDate = moment().add(MIN_DELAY_DAYS, 'day').startOf('day');

    return (
        <Dialog
            title={Tr('enotice_delayed_publication_title')}
            open={open}
            maxWidth='sm'
            onClose={onCancel}
        >
            <Form
                id='enotice_delayed_publication'
                initialValues={{
                    preferredPublicationDate: null,
                    sendNow: false,
                }}
                validationSchema={Yup.object().shape({
                    preferredPublicationDate: ValidationShema.dateMinNoRq(
                        minDelayedPublicationDate,
                        Tr('enotice_delayed_publication_min_date')
                    ).when('sendNow', {
                        is: false,
                        then: ValidationShema.dateMin(
                            minDelayedPublicationDate,
                            Tr('enotice_delayed_publication_min_date')
                        ),
                    }),
                })}
                onSubmit={(values) => {
                    const preferredPublicationDate = values.sendNow
                        ? null
                        : values.preferredPublicationDate?.format('YYYY-MM-DD') || null;
                    onConfirm(preferredPublicationDate);
                }}
            >
                {(formikProps) => (
                    <GridBlock direction='column'>
                        <Typography>{Tr('enotice_delayed_publication_content')}</Typography>
                        <DatePicker
                            id='preferredPublicationDate'
                            formikProps={formikProps}
                            label={Tr('enotice_delayed_publication_date')}
                            minDate={minDelayedPublicationDate}
                            disabled={formikProps.values.sendNow}
                            onChange={(value) => {
                                if (value) {
                                    formikProps.setFieldValue('sendNow', false);
                                }
                            }}
                        />
                        <Checkbox
                            id='sendNow'
                            formikProps={formikProps}
                            label={Tr('enotice_delayed_publication_send_now')}
                            onChange={(event) => {
                                if (event?.target?.checked) {
                                    formikProps.setFieldValue('preferredPublicationDate', null);
                                }
                            }}
                        />
                        <Typography color='error'>
                            {Tr('enotice_delayed_publication_warning')}
                        </Typography>
                        <DoubleButton
                            justify='flex-end'
                            labelFirst={Tr('cancel')}
                            labelSecond={Tr('confirm2')}
                            onClickFirst={onCancel}
                            onClickSecond={formikProps.submitForm}
                        />
                    </GridBlock>
                )}
            </Form>
        </Dialog>
    );
}

DelayedPublicationPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default DelayedPublicationPopup;

